export default (fill) => (
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 137.2">
    <path fill="#D0E0E1" d="M0 12.5C0 5.6 5.6 0 12.5 0h54L100 34.1v90.7c0 6.9-6 12.5-12.9 12.5H12.5c-6.9 0-12.5-5.6-12.5-12.5V12.5z"/>
    <text transform="translate(24.762 113.434)" fill="#6D7577" font-family="'HelveticaNeue'" font-size="34.461">TIF
    </text>
    <path fill="${fill? fill : '#A1AFAF'}" d="M66.5 0v34.1H100L66.5 0z"/>
</svg>`
)


// WEBPACK FOOTER //
// ./components/Icon/icons/files/tif.jsx